<template>
  <div id="modal-info-body">
    <h2 style="text-align: center">Indicadores Previne Brasil</h2>
    <p>
      Aqui, pode-se importar os resultados dos indicadores do quadrimestre atual
      liberados no
      <a
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        target="_blank"
        >SISAB</a
      >, os quais podem ser acessados pelos Gestores municipais com acesso
      restrito no SISAB.
    </p>
    <br />
    <p>
      Como os profissionais de saúde das equipes, geralmente, não têm acesso ao
      SISAB na área restrita, então, quadrimestralmente, importar esses dados
      aqui contribui para a democratização dos mesmos e facilita a análise dos
      profissionais de saúde nas reuniões de equipe.
    </p>
    <h3><strong>BAIXAR OS ARQUIVOS DO SISAB</strong></h3>
    <p>
      Para baixar o arquivo com o
      <a
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorCadastro.xhtml"
        target="_blank"
        >resultado dos cadastros do SISAB</a
      >, com o acesso restrito, você deve ir na aba
      <strong>Painel de Cadastros</strong> e na área de
      <strong>Definir os filtros para consulta</strong>, escolher as seguintes
      opções: <strong>Nível de visualização</strong> (CNES + INE),
      <strong>Condição das Equipes</strong> (Considerar todas as equipes do
      município), <strong>Competência</strong> (Selecionar a competência mais
      atual) e <strong>Como deseja visualizar</strong>? (clicar no botão
      download e na opção Excel).
    </p>
    <p>
      <br />
      Para baixar os arquivos contendo os resultados dos indicadores, você deve
      ir na aba
      <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/municipio/indicadores/indicadorPainel.xhtml"
        >indicadores de desempenho no SISAB</a
      >
      com o acesso restrito na área de <strong>Filtros para consulta</strong>,
      selecionar os seguintes parâmetros: <strong>Indicador</strong> (escolha o
      indicador que deseja baixar os dados),
      <strong>Nível de visualização</strong> (CNES + INE),
      <strong>Opção de quadrimestre</strong> (escolher o quadrimestre mais
      atual), <strong>Visão das Equipes</strong> (Considerar todas as equipes do
      município), e em <strong>Como deseja visualizar?</strong> (clicar no botão
      download e na opção Excel). O arquivo contendo o resultado detalhado por
      equipe do indicador selecionado é baixado para seu computador.
    </p>
    <h3>ATENÇÃO</h3>
    <p>
      Ao baixar os arquivos com resultados dos indicadores, não selecionar em
      <strong>Filtros para consulta</strong> a opção
      <strong>Visão geral</strong> (mostra uma tabela com o resultado por
      equipe, mas não mostra o valor do numerador, denominador e outras
      informações necessárias) ou
      <strong>Indicador Sintético Final</strong> (mostra o resultado municipal,
      mas não por equipe).
    </p>
    <br />
    <p>
      Ao baixar o arquivo com resultado de cadastro, não selecionar a opção
      <strong
        >considerar apenas a população com critério de vulnerabilidade</strong
      >.
    </p>
    <h3>FUNCIONALIDADES</h3>
    <p>
      Essa área permite salvar aqui no sistema de Monitoramento e Avaliação na
      APS a população estimada pelo IBGE para o ano atual. Salvar também a
      tipologia do município que interfere diretamente nos parâmetros do
      Informatiza APS e realizar a importação dos cadastros e o conjunto de
      indicadores.
    </p>
    <p>
      Detalhamento e como usar os campos disponíveis (ao seguir estas
      instruções, antes ler a seção
      <strong>BAIXAR OS ARQUIVOS DO SISAB</strong>):
    </p>
    <br />
    <ul>
      <li>
        <strong>População IBGE</strong> – digitar o valor atual estimado pelo
        <a
        target="_blank"
        href="https://cidades.ibge.gov.br/"
        >IBGE</a
      > e clicar no botão salvar;
      </li>
      <li>
        <strong>Tipologia</strong> – escolher corretamente a <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorCadastro.xhtml"
        >tipologia do IBGE</a>
        atribuída ao município e clicar no botão salvar;
      </li>
      <li>
        <strong>Parâmetro cadastro e resultado atual cadastros</strong> – baixar
        o <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorCadastro.xhtml"
        >arquivo de cadastros do SISAB</a>, selecionar ele no seu computador e
        clicar no botão importar;
      </li>
      <li>
        <strong>Consultas pré-natal</strong> – baixar o arquivo do indicador de
        <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        >pré-natal do SISAB</a
      > pelo acesso restrito, selecioná-lo no computador e
        clicar em importar;
      </li>
      <li>
        <strong>Exames HIV e Sífilis</strong> - baixar o arquivo do indicador de
         <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        >exames de HIV e sífilis do SISAB</a
      > pelo acesso restrito, selecioná-lo no
        computador e clicar em importar;
      </li>
      <li>
        <strong>Consultas odontológicas</strong> - baixar o arquivo do indicador
        de <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        >consultas odontológicas na gestante do SISAB</a
      > pelo acesso restrito,
        selecioná-lo no computador e clicar em importar;
      </li>
      <li>
        <strong>Indicador citopatológico</strong> - baixar o arquivo do
        indicador de <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        >imunização do SISAB</a
      > pelo acesso restrito, selecioná-lo no
        computador e clicar em importar;
      </li>
      <li>
        <strong>Atendimento hipertensão</strong> - baixar o arquivo do indicador
        de <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        >hipertensão do SISAB</a
      > pelo acesso restrito, selecioná-lo no computador
        e clicar em importar;
      </li>
      <li>
        <strong>Atendimento diabetes</strong> - baixar o arquivo do indicador de
        <a
        target="_blank"
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        >diabetes do SISAB</a
      > pelo acesso restrito, selecioná-lo no computador e
        clicar em importar;
      </li>
    </ul>
    <br />
    <p>
      Durante a importação de qualquer arquivo, se aparecer um aviso de erro,
      então, deve-se conferir se está importando o arquivo adequado.
    </p>
    <h3>ATENÇÃO</h3>
    <p>
      A importação desses dados aqui no sistema de Monitoramento e Avaliação na
      APS, deve ser feita ao sair o resultado de cada quadrimestre que é
      publicado no SISAB.
    </p>
    <h3>CONCLUSÃO</h3>
    <p>
      A importação desses dados interfere diretamente na qualidade da informação
      para o filtro de resultado definitivo disponível nos CARDS:
      <strong>Informatiza APS</strong> (INÍCIO >> Informatiza APS),
      <strong>Desempenho por Indicador</strong> (INÍCIO >> Indicadores APS >>
      Desempenho por equipe >> Desempenho por Indicador) e
      <strong>Desempenho Geral</strong> (INÍCIO >> Indicadores APS >> Desempenho
      por equipe >> Desempenho Geral).
    </p>
  </div>
</template>
<script>
export default {
  name: 'DocIndicadoresPrevineBrasil',
}
</script>
<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
#modal-info-body .notas-tecnicas {
  text-align: start;
  border-bottom: 1px solid #c1c1c1;
}
#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>
